import { render, staticRenderFns } from "./Courier.vue?vue&type=template&id=5a66a15d&scoped=true&"
import script from "./Courier.vue?vue&type=script&lang=js&"
export * from "./Courier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66a15d",
  null
  
)

export default component.exports